module.exports = __webpack_public_path__ + "static/media/banniere.b03ba1ec.png";